import * as React from 'react'
import { createPortal } from 'react-dom'

interface ModalPortalProps {
  children: React.ReactNode
}

export const ModalPortal: React.FC<ModalPortalProps> = ({ children }) => {
  const domElementRef = React.useRef(null)
  if (!domElementRef.current) {
    domElementRef.current = document.createElement('div')
  }

  React.useLayoutEffect(() => {
    document.body.appendChild(domElementRef.current)
    return () => document.body.removeChild(domElementRef.current)
  }, [])

  return createPortal(children, domElementRef.current)
}
